export const getDateRange = (periodValue: string | null): { dateFrom: Date | string; dateTo: Date | string } => {
  const now = new Date();
  let dateFrom, dateTo;

  if (periodValue === 'today') {
    dateFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate()).toISOString();
    dateTo = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).toISOString();
  } else if (periodValue === 'yesterday') {
    dateFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1).toISOString();
    dateTo = new Date(now.getFullYear(), now.getMonth(), now.getDate()).toISOString();
  } else if (periodValue === 'this_week') {
    const firstDayOfWeek = new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay());
    dateFrom = firstDayOfWeek.toISOString();
    dateTo = new Date(now.getFullYear(), now.getMonth(), now.getDate() + (7 - now.getDay())).toISOString();
  } else if (periodValue === 'this_month') {
    dateFrom = new Date(now.getFullYear(), now.getMonth(), 1).toISOString();
    dateTo = new Date(now.getFullYear(), now.getMonth() + 1, 1).toISOString();
  } else {
    dateFrom = '';
    dateTo = '';
  }

  return { dateFrom, dateTo };
};
